import Vue from "vue";
import VueRouter from "vue-router";
import login from '@/page/login.vue';
import join from '@/page/join.vue';
import embedded_survey from '@/page/embedded_survey/embedded_survey.vue';
import embedded_survey_subject from "@/page/embedded_survey/embedded_survey_subject.vue";
import embedded_survey_result from "@/page/embedded_survey/embedded_survey_result.vue";
import reserve_subject from "@/page/reserve/reserve_subject.vue";
import reserve from "@/page/reserve/reserve.vue";
import coach_recom from "@/page/recom/coach_recom.vue";
import coach_view from "@/page/recom/coach_view.vue";
import home from "@/page/home.vue";
import reservation_coaching from "@/page/my_coaching/reservation_coaching.vue";
import reservation_coaching_view from "@/page/my_coaching/reservation_coaching_view.vue";
import reservation_change from "@/page/my_coaching/reservation_change.vue";
import complate_coaching from "@/page/my_coaching/complate_coaching.vue";
import coaching_finish from "@/page/my_coaching/coaching_finish.vue";
import relection_notes from "@/page/my_coaching/reflection_notes.vue";
import coach_comment from "@/page/my_coaching/coach_comment.vue";
import satisfaction from "@/page/my_coaching/satisfaction.vue";
import coaching_message from "@/page/my_coaching/coaching_message.vue";
import message from "@/page/my_coaching/message.vue";
import myinfo from "@/page/myinfo.vue";
import password_trans from "@/page/password_trans.vue";
import password_account from "@/page/password_account.vue";
import privacy from "@/page/privacy.vue";
import coaching_goal from "@/page/reserve/coaching_goal.vue";
import coaching_goal_modify from "@/page/reserve/coaching_goal_modify.vue";
import reserve_finish from "@/page/reserve/reserve_finish.vue";
import sample from "@/page/sample.vue";
import reserve_subject_sub from "@/page/reserve/reserve_subject_sub.vue";
import coach_recommend_video from "@/page/recom/coach_recommend_video.vue";
import reflection_notes_modify from "@/page/my_coaching/reflection_notes_modify.vue";
import landing from "@/page/landing.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: login,
  },
  {
    path: "/sample",
    name: "sample",
    component: sample,
  },
  {
    path: "/join",
    name: "join",
    component: join,
    props:true
  },
  {
    path: "/embedded_survey",
    name: "embedded_survey",
    component: embedded_survey,
  },
  {
    path: "/embedded_survey_subject",
    name: "embedded_survey_subject",
    component: embedded_survey_subject,
  },
  {
    path: "/embedded_survey_result/:view",
    name: "embedded_survey_result",
    component: embedded_survey_result,
    props:true
  },
  {
    path: "/reserve_subject/:rebook/:coachIdx",
    name: "reserve_subject",
    component: reserve_subject,
    props:true
  },
  {
    path: "/reserve/:idx/:rebook",
    name: "reserve",
    component: reserve,
    props:true
  },
  {
    path: "/coach_recom/:rebook",
    name: "coach_recom",
    component: coach_recom,
    props:true
  },
  {
    path: "/coach_view/:idx/:rebook",
    name: "coach_view",
    component: coach_view,
    props:true
  },
  {
    path: "/home",
    name: "home",
    component: home,
  },
  {
    path: "/reservation_coaching",
    name: "reservation_coaching",
    component: reservation_coaching,
  },
  {
    path: "/reservation_coaching_view/:sessionIdx",
    name: "reservation_coaching_view",
    component: reservation_coaching_view,
    props:true
  },
  {
    path: "/reservation_change/:sessionIdx",
    name: "reservation_change",
    component: reservation_change,
    props:true
  },
  {
    path: "/complate_coaching",
    name: "complate_coaching",
    component: complate_coaching,
  },
  {
    path: "/coaching_finish/:sessionIdx",
    name: "coaching_finish",
    component: coaching_finish,
    props:true
  },
  {
    path: "/relection_notes/:idx",
    name: "relection_notes",
    component: relection_notes,
    props:true
  },
  {
    path: "/coach_comment/:idx",
    name: "coach_comment",
    component: coach_comment,
    props:true
  },
  {
    path: "/satisfaction/:idx",
    name: "satisfaction",
    component: satisfaction,
    props:true
  },
  {
    path: "/coaching_message",
    name: "coaching_message",
    component: coaching_message,
  },
  {
    path: "/message/:coarchIdx",
    name: "message",
    component: message,
    props:true
  },
  {
    path: "/myinfo",
    name: "myinfo",
    component: myinfo,
  },
  {
    path: "/password_trans/:idx/:isAccount",
    name: "password_trans",
    component: password_trans,
    props:true
  },
  {
    path: "/password_account/:isAccount",
    name: "password_account",
    component: password_account,
    props:true
  },
  {
    path: "/privacy",
    name: "privacy",
    component: privacy,
  },
  {
    path: "/coaching_goal",
    name: "coaching_goal",
    component: coaching_goal,
  },
  {
    path: "/reserve_finish",
    name: "reserve_finish",
    component: reserve_finish,
  },
  {
    path: "/reserve_subject_sub",
    name: "reserve_subject_sub",
    component: reserve_subject_sub,
  },
  {
    path:"/coach_recommend_video",
    name:"coach_recommend_video",
    component:coach_recommend_video
  },
  {
    path:"/coaching_goal_modify/:sessionIdx",
    name:"coaching_goal_modify",
    component:coaching_goal_modify,
    props:true
  },
  {
    path:"/reflection_notes_modify/:idx",
    name:"reflection_notes_modify",
    component:reflection_notes_modify,
    props:true
  },
  {
    path:"/landing",
    name:"landing",
    component:landing,
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
